import React from 'react'
import ChangelogInstance from '../ChangelogInstance';

const ThreeDotFourDotOne = () => {
  return (
    <ChangelogInstance version="3.4.1" date="2025-08-22">
      <li>
        Added support for Souvenir Charms
      </li>
      <li>
        Fixed lots of bugs introduced in the previous version
      </li>
      <li>
        Added iTrade.gg and White.Market affiliate links
      </li>
      <li>
        Removed csgoexo and skinwallet as pricing providers
      </li>
    </ChangelogInstance>
  );
}

export default ThreeDotFourDotOne;